import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { RequireAuth, RequireAdmin } from './components/RouteGuards';
import NavBar from './components/NavBar';
import Classifier from './pages/Classifier';
import UploadData from './pages/UploadData';
import Database from './pages/Database';
import AdminPage from './pages/AdminPage';
import Hours from './pages/Hours';
import './App.css';

function App() {
  const { user, logout, userDoc } = useAuth();
  return (
    <Router>
      <div className="App">
        <NavBar user={user} logout={logout} userDoc={userDoc} />
        <Routes>
          <Route path="/" element={<RequireAuth><Classifier /></RequireAuth>} />
          <Route path="/hours" element={<RequireAuth><Hours /></RequireAuth>} />
          <Route path="/upload" element={<RequireAuth><RequireAdmin><UploadData /></RequireAdmin></RequireAuth>} />
          <Route path="/database" element={<RequireAuth><RequireAdmin><Database /></RequireAdmin></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth><RequireAdmin><AdminPage /></RequireAdmin></RequireAuth>} />
        </Routes>
      </div>
    </Router>
  );
}

export default function WrappedApp() {
  return <AuthProvider><App /></AuthProvider>;
}
